import { render, staticRenderFns } from "./CollapseBar.vue?vue&type=template&id=19c4bfda&scoped=true"
import script from "./CollapseBar.vue?vue&type=script&lang=js"
export * from "./CollapseBar.vue?vue&type=script&lang=js"
import style0 from "./CollapseBar.vue?vue&type=style&index=0&id=19c4bfda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4bfda",
  null
  
)

export default component.exports